/**
 * Perguntas que a conversa vazia oferece (R26). A cada conversa nova saem algumas, sorteadas
 * entre as que o cargo pode fazer. `acoes`: basta uma (contracts/enums.yaml); vazio = todos.
 */
export type SugestaoInicialMia = { texto: string; acoes: number[] };

export const SUGESTOES_INICIAIS_MIA: SugestaoInicialMia[] = [
  { texto: 'Onde registro a entrada?', acoes: [] },
  { texto: 'Como funciona a agenda?', acoes: [] },
  { texto: 'Como cadastro um aluno?', acoes: [] },
  { texto: 'Quais são as minhas notificações?', acoes: [] },
  { texto: 'Crie um recado para um aluno', acoes: [802] },
  { texto: 'Quem ainda não chegou hoje?', acoes: [901, 902] },
  { texto: 'O que está pendente hoje?', acoes: [801, 802, 901, 902] },
  { texto: 'Como foi o dia da escola hoje?', acoes: [801, 802, 901, 902, 1001, 1101, 1201, 1301] },
  { texto: 'Marque um evento na agenda', acoes: [1701] },
];

export const QUANTAS_SUGESTOES_MIA = 3;

/** Sorteia `quantas` sugestoes do cargo, sem repetir (Fisher-Yates parcial). */
export function sortearSugestoesMia(
  acoes: readonly number[],
  quantas = QUANTAS_SUGESTOES_MIA,
  aleatorio: () => number = Math.random,
): string[] {
  const doCargo = SUGESTOES_INICIAIS_MIA.filter(
    (s) => s.acoes.length === 0 || s.acoes.some((a) => acoes.includes(a)),
  ).map((s) => s.texto);
  for (let i = 0; i < Math.min(quantas, doCargo.length); i += 1) {
    const j = i + Math.floor(aleatorio() * (doCargo.length - i));
    [doCargo[i], doCargo[j]] = [doCargo[j], doCargo[i]];
  }
  return doCargo.slice(0, quantas);
}
